import { GmapComponent } from './gmap.component';
import { GmapsTravelMode } from './../common-theme/gmaps/gmaps-interface/gmaps-travel-mode.model';
import { Component, OnInit, AfterViewInit, ViewChild, Injector, OnDestroy } from '@angular/core';
import { AgencyService } from '../common-theme/api/agency.service';
import { GmapsPoint } from '../common-theme/gmaps/gmaps-point.model';
import { SeoAwareBaseComponent } from '../common-theme/seo/seo-aware-base.component';
import { ScrollToService, ScrollToConfigOptions } from '@nicky-lenaers/ngx-scroll-to';
import { Subscription } from 'rxjs/Subscription';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-localisation',
  templateUrl: './localisation.component.html',
  styleUrls: ['./localisation.component.scss']
})

export class LocalisationComponent extends SeoAwareBaseComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(GmapComponent) googleMap: GmapComponent;
  travelModes: GmapsTravelMode[] = [];
  translateSubscription: Subscription = new Subscription();
  subscription: Subscription = new Subscription();
  pointsOfInterestCategories: any[] = [];
  textAddition: string;

  constructor(
    public agencyService: AgencyService,
    public injector: Injector,
    private _scrollToService: ScrollToService,
    public translateService: TranslateService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.travelModes = [
      new GmapsTravelMode(
        'drive',
        'assets/icons/gmaps/car.svg'
      ),
      new GmapsTravelMode(
        'transit',
        'assets/icons/gmaps/transit.svg'
      ),
      new GmapsTravelMode(
        'walk',
        'assets/icons/gmaps/walk.svg'
      )
    ];

    this.pointsOfInterestCategories = this.getCategories(this.getInterestPoints());

    this.getTextAddition();

    this.subscription.add(this.translateService.onLangChange
      .subscribe(() => {
        this.pointsOfInterestCategories = this.getCategories(this.getInterestPoints());
        this.getTextAddition();
      })
    );

    this.setTitle('Localizarea proiectului Romanescu Park Residence');

    this.setMetaDescription(`
      Proiectul Romanescu Park Residence este situat la numai câțiva pași de Parcul Romanescu din
      Craiova, dar în apropiere sunt o mulțime de alte puncte de interes. Folosește harta noastră
      interactivă pentru a le afla localizarea exactă.
    `);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.translateSubscription.unsubscribe();
  }

  ngAfterViewInit(): void {
    this.googleMap.initGmapsDirections(
      new GmapsPoint(
        parseFloat(this.agencyService.agency.latitude.toString()),
        parseFloat(this.agencyService.agency.longitude.toString())
      ),
      undefined,
      this.googleMap.interface.locationSearchInput.destinationRef
    );
  }

  private getTextAddition(): void {
    this.translateSubscription.add(
      this.translateService.get('model.gmaps.additional_text')
        .subscribe((translatedString: string) => {
          this.textAddition = translatedString;
        })
    );
  }

  private getInterestPoints(): any {
    const interestPoints = [];

    for (let i = 1; i <= 48; i++) {
      const interestPoint = {
        title: '',
        latitude: '',
        longitude: '',
        category_id: ''
      };

      this.translateSubscription.add(
        this.translateService.get('points_of_interest.' + i + '.title')
          .subscribe((translatedString: string) => {
            interestPoint.title = translatedString;
          })
      );

      this.translateSubscription.add(
        this.translateService.get('points_of_interest.' + i + '.category_id')
          .subscribe((translatedString: string) => {
            interestPoint.category_id = translatedString;
          })
      );

      this.translateSubscription.add(
        this.translateService.get('points_of_interest.' + i + '.latitude')
          .subscribe((translatedString: string) => {
            interestPoint.latitude = translatedString;
          })
      );

      this.translateSubscription.add(
        this.translateService.get('points_of_interest.' + i + '.longitude')
          .subscribe((translatedString: string) => {
            interestPoint.longitude = translatedString;
          })
      );

      interestPoints.push(interestPoint);
    }

    return interestPoints;
  }

  private getCategories(interestPoints: any): any {
    const categories = [];

    for (let i = 1; i <= 9; i++) {
      const interestPointsCat = {
        title: '',
        icon: '',
        points: []
      };

      this.translateSubscription.add(
        this.translateService.get('poi_categories.' + i + '.title')
          .subscribe((translatedString: string) => {
            interestPointsCat.title = translatedString;
          })
      );

      this.translateSubscription.add(
        this.translateService.get('poi_categories.' + i + '.icon')
          .subscribe((translatedString: string) => {
            interestPointsCat.icon = translatedString;
          })
      );

      interestPointsCat.points = interestPoints.filter(ip => parseInt(ip.category_id) === i);

      categories.push(interestPointsCat);
    }

    return categories;
  }

  public onInterestPointClick(point: any): void {
    this.googleMap.updatePath(point.latitude, point.longitude, `${this.textAddition} ${point.title}`);

    this.triggerScrollTo('map');
  }

  public triggerScrollTo(target: string): void {
    const config: ScrollToConfigOptions = {
      target: target
    };

    this._scrollToService.scrollTo(config);
  }
}



// WEBPACK FOOTER //
// ./src/app/localisation/localisation.component.ts